import type { UseDocumentProps } from '@ztechapps/common.hook'
import { useDocument } from '@ztechapps/common.hook'
import type { Task } from '@ztechapps/common.contract'
import { useTaskIdParam } from './useTaskIdParam'
import { taskDocumentQueries } from './graphql'

export const useTaskDocument = ({ query, ...props } = {} as Partial<UseDocumentProps>) => {
  const taskId = useTaskIdParam()

  const defaultQuery = query ?? taskDocumentQueries.singleConfig.query

  return useDocument<Task>({ query: defaultQuery, _id: taskId, ...props })
}
